export default __webpack_public_path__ + "intouch-logo.c946fc40.png";